var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "download_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    overflow: "visible",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_svg__surface1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M7.1,27.6c-1.1,0-2-0.4-2.8-1.2c-0.7-0.7-1.2-1.7-1.2-2.8l0-3.3c0-0.5,0.4-1,1-1s1,0.4,1,1l0,3.3 c0,0.5,0.2,1,0.6,1.4s0.9,0.6,1.4,0.6h17.9c1.1,0,2-0.9,2-2l0-3.2c0-0.5,0.4-1,1-1c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7 l0,3.2c0,2.2-1.8,3.9-3.9,3.9H7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M24.9,27.2H7.1c-0.9,0-1.8-0.4-2.5-1c-0.7-0.7-1-1.5-1-2.5l0-3.3c0-0.3,0.2-0.5,0.5-0.5h0 c0.3,0,0.5,0.2,0.5,0.5l0,3.3c0,0.7,0.3,1.3,0.7,1.7c0.5,0.5,1.1,0.7,1.7,0.7h17.9c1.4,0,2.5-1.1,2.5-2.5l0-3.2 c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5l0,3.2C28.4,25.6,26.9,27.2,24.9,27.2L24.9,27.2z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 19,
    xlinkHref: "/A6BEC472D9177D3E.png",
    transform: "matrix(1 0 0 1 10 4)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 10,
    height: 18,
    xlinkHref: "/A6BEC472D9177D42.png",
    transform: "matrix(1 0 0 1 11 4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9796e6b9b8f6984c5b59ec2a3c7b3719.svg";
export { ForwardRef as ReactComponent };